import './style.css'
import Master from '../../layout/Master';
import Sidbar from '../../layout/Sidbar';
import Card from '../../layout/Card';
import Image from './image';
import { useRef, useState } from 'react';
import { FaWindowClose } from "react-icons/fa";
import {connect} from 'react-redux';
const Gallery = () => {

    const imageGallory = [
        {id: 1, url: "/image/Gallery/Dr Modaggeg Garah Orog 10,5,84 048.jpg", text: ""},
        {id: 2, url: "/image/Gallery/DSC_0002.jpg", text: ""},
        {id: 3, url: "/image/Gallery/DSC_0005.jpg", text: ""},
        {id: 4, url: "/image/Gallery/DSCN1978.JPG", text: ""},
        {id: 5, url: "/image/Gallery/gashn  roz  pezeshk  17.JPG", text: ""},
        {id: 6, url: "/image/Gallery/IMG_0870.JPG", text: ""},
        {id: 7, url: "/image/Gallery/IMG_0956-copy-scaled.jpg", text: ""},
        {id: 8, url: "/image/Gallery/IMG_2391.JPG", text: ""},
        {id: 10, url: "/image/Gallery/IMG_4570-copy-scaled.jpg", text: ""},
        {id: 11, url: "/image/Gallery/IMG_6573.JPG", text: ""},
        {id: 12, url: "/image/Gallery/IMG_6109-copy-scaled.jpg", text: ""},
        {id: 13, url: "/image/Gallery/IMG_7636-copy-scaled.jpg", text: ""},
        {id: 14, url: "/image/Gallery/IMG_9151.JPG", text: ""},
        {id: 15, url: "/image/Gallery/IMG_9195.JPG", text: ""},
        {id: 16, url: "/image/Gallery/photo_2017-12-07_07-42-01.jpg", text: ""},
        {id: 17, url: "/image/Gallery/Picture 013.jpg", text: ""},
        {id: 18, url: "/image/Gallery/Picture 212.jpg", text: ""},
        {id: 19, url: "/image/Gallery/todi (5).jpg", text: ""},
        {id: 20, url: "/image/Gallery/todi (15).jpg", text: ""},

    ];
    const [images, setImages] = useState(imageGallory);
    
    const closeImageShowHandler = (event=null) => {
        
        let containerImageShow = document.getElementById("containerImageShow");
        containerImageShow.style.opacity = 0;
        containerImageShow.style.visibility = "hidden";
        if(event.currentTarget){
            // alert("yess");   
        }
        // console.log(event.currentTarget);
    }

    const nextImage = () => {
            alert("nextImage")
    }
    const priviewImage = () => {
            // console.log(images());
    }
    
    return (
        <>
            <Master>
                <Sidbar>
                    <Card>
                        <div className='imageShow' id='containerImageShow' > 
                        
                        <input type={`hidden`} id="idImageSelected" />
                            <div style={{ position:"fixed", left: "20px",fontSize: "50px", zIndex: "999", color: "#fff", lineHeight: "10"}} onClick={() => nextImage()}>
                                <p ></p> 
                            </div>
                            <FaWindowClose className='btnCloseModulHowImage' style={{}} onClick={() => closeImageShowHandler()}/>
                            <Image id={`imageShow`}   url={`/image/Gallery/IMG_6109-copy-scaled.jpg`} divClassName="" imageClassName="positionSowImage "/>
                         
                            <div style={{ position:"fixed",fontSize: "20px", zIndex: "555", color: "#fff", bottom: "50px", width: "100%"}} >
                                <p id='discriptionImage' className='h-5'></p> 
                            </div>
                            <div style={{ position:"fixed", right: "20px",fontSize: "50px", zIndex: "999", color: "#fff", lineHeight: "10"}} onClick={() => priviewImage()}>
                                <p ></p> 
                            </div>
                        </div>
                        <div className='Images'>
                            <h2>گالری دکتر هادی مدقق</h2>
                        {
                            images.map((row, index) => 
                                <Image url={row.url} text = {row.text} imageId={row.id}  />
                            )
                        }
                            
                        </div>
                    </Card>
                </Sidbar>
            </Master>
        </>
    )
}

// function mapStateToProps(state){
//     return {
//         images: state.imageState.item
//     }
// }
// export default connect(mapStateToProps, mapDispatchToProps)(Users);
// export default connect(mapStateToProps)(Gallery);

export default Gallery;

